import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { trackEvent } from "@/lib/analytics";

// Configurar axios global para enviar cookies
axios.defaults.withCredentials = true;

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setUser(data);
    trackEvent("login_completed", { method: "password", is_pro: !!data?.es_pro });
    return data;
  };

  const register = async (email, password, razon_social) => {
    const { data } = await axios.post(`${API}/auth/register`, {
      email,
      password,
      razon_social: razon_social || null,
    });
    setUser(data);
    trackEvent("signup_completed", { method: "password" });
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch {
      // ignore logout error
    }
    setUser(null);
    trackEvent("logout");
  };

  const refresh = fetchMe;

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth fuera de AuthProvider");
  return ctx;
}
